<template>
    <div class="main">
      <p>账号</p>
      <mt-field placeholder="请输入手机号" type="tel" v-model="userName"></mt-field>
      <span v-if="showError" class="error">请输入有效的电话号码！</span>
      <p>密码</p>
      <mt-field placeholder="请输入密码" type="password" v-model="password"></mt-field>
      <span v-if="showPasswordError" class="error">请输入密码！</span>
      <p class="forget" @click="loginCode">快捷登录！</p>
      <span v-if="loginStatus" class="error">账号或密码错误！</span>
      <mt-button class="save" @click="login()">登录</mt-button>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import axios from 'axios';
  import router from '../../router/router';
  import { ApiPath } from '../../fetch/config';
  import Container from '../../utils/container.js';
  import {randomLetNum } from '../../utils/utils';
  import Assert from '../../utils/assert';
  import Auth from '../../utils/auth';
  export default {
    name: '',
    data() {
      return {
        userName: '',
        password: '',
        showError: false,
        showPasswordError: false,
      }
    },
    computed: {
      ...mapGetters('user', {
        loginConfig: 'getLoginConfig',
        loginStatus: 'login'
      })
    },
    methods: {
      loginCode: function() {
        let refer = this.$route.query.refer||'/';
        this.$router.replace({name:'loginCode',query:{refer}});
      },
      login: function() {
        this.showPasswordError = false;
        this.showError = false;
        this.$store.dispatch('user/initLogin');
        const reg=/^[1][3,4,5,7,8][0-9]{9}$/;
        if (!reg.test(this.userName)) {
          this.showError = true;
          return;
        }
        if (this.password.trim() === '') {
          this.showPasswordError = true;
          return;
        }
        let refer = this.$route.query.refer||'/';
        this.$store.dispatch('user/login', { phone: this.userName, passwd: this.password,refer:refer })
      }
    }
  }
</script>
<style lang="scss"  scoped>
  @import "../../assets/scss/login.scss";
  </style>




// WEBPACK FOOTER //
// src/components/loginComponents/LoginView.vue